// extracted by extract-css-chunks-webpack-plugin
module.exports = {"text-field":"styles__text-field___1OiE_","textField":"styles__text-field___1OiE_","color-picker-text":"styles__color-picker-text___26dag","colorPickerText":"styles__color-picker-text___26dag","color-picker-button":"styles__color-picker-button___rhdMY","colorPickerButton":"styles__color-picker-button___rhdMY"};
    if(module.hot) {
      // 1770059385708
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  